import React from 'react';
import PropTypes from 'prop-types';

export default class PromoNumberLabel extends React.Component {
  render() {
    return (
      <div className="sb-field-group" id="promo_number_field">
        <label className="sb-field-label">Promo Number</label>
        <div id="promo_number_fixed">{this.props.promoNumber}</div>
      </div>
    );
  }
}

PromoNumberLabel.propTypes = {
  promoNumber: PropTypes.string.isRequired
};
